var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cal-sans-regular black--text font-size-28 pb-2 mt-3",staticStyle:{"border-bottom":"3px solid #4caf50"}},[_vm._v("World Building")])])
}]

export { render, staticRenderFns }